import {store} from "@/store";

export default {
    isMobile() {
        const platform = store.state.launchParams["vk_platform"];
        if (! platform) {
            return false;
        }

        return platform.indexOf("mobile") > -1;
    }
}